const translations = {
    fr: {
      legal: "Mentions légales",
      privacy: "Politique de confidentialité",
      terms: "Conditions d'utilisation",
    },
    en: {
      legal: "Legal Notice",
      privacy: "Privacy Policy",
      terms: "Terms of Use",
    },
    de: {
      legal: "Impressum",
      privacy: "Datenschutzrichtlinie",
      terms: "Nutzungsbedingungen",
    },
    es: {
      legal: "Aviso legal",
      privacy: "Política de privacidad",
      terms: "Términos de uso",
    },
    it: {
      legal: "Note legali",
      privacy: "Informativa sulla privacy",
      terms: "Condizioni d'uso",
    },
  };
  
  export default translations;
  